import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import TrafficLightBar from "../TrafficLightBar";
import style from "./style.module.scss";
export default function LegendTrafficLight(props) {
    const { min, goodWarningTransition, warningBadTransition, max, goodColor, warningColor, badColor } = props;
    const trafficLightSegments = [];
    //Add the Good metric.
    const goodSegment = {
        id: "good",
        value: 10,
        color: goodColor,
    };
    //Add the Warning metric.
    const warningSegment = {
        id: "warning",
        value: 10,
        color: warningColor,
    };
    //Add the Bad metric.
    const badSegment = {
        id: "bad",
        value: 10,
        color: badColor,
    };
    trafficLightSegments.push(goodSegment);
    trafficLightSegments.push(warningSegment);
    trafficLightSegments.push(badSegment);
    return (_jsxs("div", { className: style["legend-traffic-light"], children: [_jsx(TrafficLightBar, { trafficLightSegments: trafficLightSegments, vertical: true }), _jsxs("div", { className: style["legend-traffic-light__labels"], children: [_jsx("div", { children: min }), _jsx("div", { children: goodWarningTransition }), _jsx("div", { children: warningBadTransition }), _jsx("div", { children: max })] })] }));
}
